"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import PencilIcon, { PencilIconSize } from "@/components/utils/icons/PencilIcon";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import WaveHeaderNameEditModal from "./WaveHeaderNameEditModal";
export default function WaveHeaderNameEdit(t0) {
  const $ = _c(7);
  const {
    wave
  } = t0;
  const [isEditNameOpen, setIsEditNameOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsEditNameOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button onClick={t1} className="tw-border-none tw-bg-transparent tw-p-0 tw-items-center desktop-hover:group-hover:tw-flex tw-hidden tw-text-iron-300 desktop-hover:hover:tw-text-iron-400 tw-duration-300 tw-ease-out tw-transition-all"><PencilIcon size={PencilIconSize.SMALL} /></button>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isEditNameOpen || $[3] !== wave) {
    t3 = isEditNameOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><WaveHeaderNameEditModal wave={wave} onClose={() => setIsEditNameOpen(false)} /></CommonAnimationOpacity>;
    $[2] = isEditNameOpen;
    $[3] = wave;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div>{t2}<CommonAnimationWrapper mode="sync" initial={true}>{t3}</CommonAnimationWrapper></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(e) {
  return e.stopPropagation();
}